// Mirrors PlaybookResponse in content-service (playbook_responses.response)
// eslint-disable-next-line no-shadow
export enum PlaybookResponse {
  Yes = 'yes',
  ToDo = 'to_do',
  No = 'no',
}

export interface PlaybookResponseRecord {
  contentId?: number;
  memberId?: string;
  response?: PlaybookResponse;
  updatedDate?: string;
}
